<div class="main-login-container">
  <div
    class="login-welcome-section"
    [class.login-welcome-section-landscape]="isLandscape"
    [class.login-welcome-section-responsive]="isResponsiveLandscape"
    >
    <div class="login-logo-section">
      <img [src]="imageUrl('login-page-assets/Logo.svg')" alt="Maids-cc logo" />
    </div>
    <div class="welcome-back-text">
      Welcome Back <span [innerHTML]="wavingDecimal"></span>
    </div>
    <div class="quote-section">
      <div @fadeInOut *ngIf="currentQuote" class="quote-container">
        {{ currentQuote }}
      </div>
    </div>
  </div>
  <div class="login-credentials-section">
    <form
      #form="ngForm"
      (ngSubmit)="authenticate(form.value.username, form.value.password)"
    >
      <div class="login-title-inputs">
        <div class="login-title-wrapper">
          <h1>Login</h1>
        </div>
        <div class="form-field-container">
          <div class="input-field-label">User Name</div>
          <cc-input
            autocomplete="username"
            ngModel
            name="username"
            #usernameInput
          >
          </cc-input>
          <span class="login-username-placeholder" *ngIf="!form.value.username" (click)="clickOnUsernameInput()">Enter your name</span>
        </div>
        <div class="form-field-container">
          <div class="input-field-label">Password</div>
          <cc-input
            #passwordInput
            class="password-field"
            [type]="showPassword ? 'text' : 'password'"
            autocomplete="current-password"
            ngModel
            name="password"
          >
            <cc-icon
              *ngIf="!showPassword"
              class="input-icon-suffix password-visibility-icon"
              (click)="changePasswordVisibility()"
            >
              visibility
            </cc-icon>
            <cc-icon
              *ngIf="showPassword"
              class="input-icon-suffix password-visibility-icon"
              (click)="changePasswordVisibility()"
            >
              visibility_off
            </cc-icon>
          </cc-input>
          <span class="login-password-placeholder" *ngIf="!form.value.password" (click)="clickOnPasswordInput()">Enter your password</span>
          <!-- From the management requirment to hide 'forgot passowrd' for now. remove d-none class when they decide to have this again -->
          <div class="forgot-password-container d-none">
            <a href="#">Forgot password?</a>
          </div>
        </div>
      </div>
      <div class="login-button-container">
        <button cc-raised-button color="accent" class="login-button">Login</button>
      </div>
    </form>

    <!-- Google Sign-In Section -->
    <div class="google-signin-container">
      <div class="divider-container">
        <hr class="divider-line">
        <span class="divider-text">or</span>
        <hr class="divider-line">
      </div>

      <div class="google-signin-container">
                <button
                  class="google-signin-btn custom-google-btn"
                  (click)="startGoogleAuth()"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24">
                    <path
                      fill="#4285F4"
                      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    />
                    <path
                      fill="#34A853"
                      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    />
                    <path
                      fill="#FBBC05"
                      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    />
                    <path
                      fill="#EA4335"
                      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    />
                  </svg>
                    <span>{{ "Sign in with Google" }}</span>
                  </button>
                </div>
    </div>

    <div class="refer-friends-wrapper">
      <div class="refer-friends-container">
        <div class="refer-friends-text">
          Always remember to refer your friends to join our company
          <span [innerHTML]="smileyDecimal"> </span>
        </div>
      </div>
    </div>
  </div>
</div>
